export default class OrganizationReport {
  public id: number;
  public organization_id: number;
  public name: string;
  public scope: string;
  public is_whitelisted: boolean;
  public created_at: string;
  public updated_at: string;
}
